import axios from "@/axios";

export const namespaced = true;

export const state = {
  authenticatedUser: {},
  approvedUsers: [],
  user: {},
  allUsers: [],
  allUsersForExporting: [],
  logisticsUsers: [],
  financeUsers: [],
  sponsorUsers: [],
  ousdUsers: [],
  partnerNationUsers: [],
  paginatedUsers: [],
  myUserToggle: false,
  lockSponsor: {},
  unLockSponsor: {},
  PNManagerUser:[],
  tier1Users:[],
};

const IS_APPROVED = 2;

const updateProfileConfig = {
  showToast: true,
  message: "User Details Successfully Saved!!",
};

export const getters = {
  authenticatedUser: (state) => state.authenticatedUser,
  getUserLockSponsor: (state) => state.lockSponsor,
  getUserUnLockSponsor: (state) => state.unLockSponsor,
  allUsers: (state) => state.allUsers,
  approvedUsers: (state) => state.approvedUsers,
  getUserToggle: (state) => state.myUserToggle,
  allUsersForExporting: (state) => state.allUsersForExporting,
  user: (state) => state.user,
  isAuthenticatedUserAssignedLogisticsRole: (state) =>
    state.user &&
    state.user.roleString &&
    state.user.roleString.split(",").includes("Logistics"),
  logisticsUsers: (state) => state.logisticsUsers,
  financeUsers: (state) => state.financeUsers,
  partnerNationUsers: (state) =>
    state.partnerNationUsers,
  sponsorUsers: (state) => state.sponsorUsers,
  ousdUsers: (state) => state.ousdUsers,
  paginatedUsers: (state) => state.paginatedUsers,
  tier1Users: (state) => state.tier1Users,
}

export const mutations = {
  SET_USER_TOGGLE: (state, response) => (state.myUserToggle = response),
  SET_USERS: (state, response) => (state.allUsers = response.data),
  SET_APPROVED_USERS: (state, response) => (state.approvedUsers = response.data),
  SET_USER: (state, resp) => {
    if (resp && resp.data) {
      state.user = resp.data;
    }
  },
  SET_LOCK_SPONSOR: (state, res) => {
    state.lockSponsor = res.data
  },
  SET_UNLOCK_SPONSOR: (state, res) => {
    state.unLockSponsor = res.data
  },
  SET_AUTHENTICATED_USER: (state, resp) =>
    (state.authenticatedUser = resp.data),
  SET_PAGINATED_USERS: (state, resp) => (state.paginatedUsers = resp.data),
  SET_LOGISTICS_USERS: (state, response) =>
    (state.logisticsUsers = response.data),
  SET_FINANCE_USERS: (state, response) => (state.financeUsers = response.data),
  SET_SPONSOR_USERS: (state, response) => (state.sponsorUsers = response.data),
  SET_OUSD_USERS: (state, response) => (state.ousdUsers = response.data),
  SET_PARTNERNATION_USERS: (state, response) =>
    (state.partnerNationUsers = response.data),
  SET_ALL_USERS_FOR_EXPORTING: (state, response) =>
    (state.allUsersForExporting = response.data),
  REMOVE_PENDING_ROLE: (state) => {
    if (
      state.user &&
      state.user.roles &&
      state.user.roles.includes("Pending") &&
      state.user.approvalStatusId !== 1
    ) {
      state.user.roles = state.user.roles.filter((role) => {
        return role !== "Pending";
      });
    }
  },
  PNManagerUser: (state)=> state.PNManagerUser,
  SET_TIER_USER: (state)=> state.tier1Users,
};

export const actions = {
  async getUsers({ commit }) {
    commit("SET_USERS", await axios.get("/api/applicationusers"));
  },
  async setUserToggle({commit}, value) {
    commit('SET_USER_TOGGLE', value || false);
  },
  async getApprovedUsers({ commit}, includeLockedUsers = false) {
    commit("SET_APPROVED_USERS", await axios.get(`/api/applicationusers/approved/${includeLockedUsers}`));
  },
  async getAllUsersForExporting({ commit }, info) {
    //put the url splitter (/) in the variable because 
    //sponsor id and serach text are both optional

    let sponsorId = (!info.sponsorId) ? "" : `${info.sponsorId}`
    let searchText = (info.searchText == null || info.searchText == "") ? "" : `${info.searchText}`
    let result = `${searchText}${sponsorId}`;
    let end = (result == null || result == "")? "": 
     `export/${(searchText == "") ? "null": searchText}/${(sponsorId == "") ? "null": sponsorId}`
     commit( "SET_ALL_USERS_FOR_EXPORTING", 
     await axios.get(`/api/applicationusers/${end}`));
  },
  
  async getAllUsersPaginate({ commit }, info) {
    //put the url splitter (/) in the variable because 
    //sponsor id and search text are both optional

    let sponsorId = (!info.sponsorId) ? "" : `${info.sponsorId}`
    let searchText = (info.searchText == null || info.searchText == "") ? "" : `${info.searchText}`
    let result = `${searchText}${sponsorId}`;
    let end = (result == null || result == "")? "": 
      `${(searchText == "") ? "null": searchText}/${(sponsorId == "") ? "null": sponsorId}`
 
    commit("SET_PAGINATED_USERS", 
      await axios.get(`/api/applicationusers/allusers/${info.pageNumber}/${info.pageCount}/${end}`));
  },
  
  async getUser({ state, commit }, id) {
    var user = await axios.get("/api/applicationusers/id/" + id);
    commit("SET_USER", user);
  },
  async loadUserLockSponsor({state, commit }, id) {
    var ret = await axios.get(`/api/applicationusers/lock/sponsor/${id}`);
    commit("SET_LOCK_SPONSOR", ret);
  },
  
  async loadUserUnLockSponsor({state, commit }, id) {
    var ret = await axios.get(`/api/applicationusers/unlock/sponsor/${id}`);
    commit("SET_UNLOCK_SPONSOR", ret);
  },
  async clearUser({ commit }) {
    commit("SET_USER", {});
  },
  async lockUser({ state, commit }, id) {
    await axios.get("/api/applicationusers/lock/" + id, {config:updateProfileConfig});
  },
  async unlockUser({ state, commit }, id) {
    await axios.get("/api/applicationusers/unlock/" + id, {config:updateProfileConfig});
  },
  async approveUser({ state, commit }, data) {
    return await axios.post("/api/applicationusers/approve/", data, { config: {
  showToast: false}
});
  },
  async rejectUser({ state, commit }, data) {
    return await axios.post("/api/applicationusers/reject/", data, { config: {
  showToast: false}
});
  },
  // SR: Fetching Authenticated User Data on load and storing it in users vuex module.
  async getUserByEmail({ commit }) {
    commit("SET_USER", await axios.get("/api/applicationusers/email"));
    commit(
      "SET_AUTHENTICATED_USER",
      await axios.get("/api/applicationusers/email")
    );
  },
  async updateUserAdmin({ commit, state }, access = { isTier1: false, isSuperAdmin: false }) {
    try {
    const { data: loggedInUser } = await axios.get("/api/applicationusers/email" ,    { config:{ showToast: false }});
    const loggedInUserRoles = loggedInUser.roles || [];
    const targetUserRoles = state.user.roles || [];

    const isLoggedInTier1 = loggedInUserRoles.includes("Tier1");
    const isTargetTier1 = targetUserRoles.includes("Tier1");
    const isTargetSponsor = targetUserRoles.includes("Sponsor");
    const isSuperAdmin = access.isSuperAdmin || loggedInUserRoles.includes("AGATRS Team");
    const isAccessTier1 = access.isTier1 || false;

    // If access object is expected and missing required props
    if (access == null || typeof access !== "object") {
      return {
        status: false,
        res: "Missing access information. Unable to authorize user update.",
      };
    }

    // Restrict modification of Tier1 & Sponsor unless by Tier1 or SuperAdmin
    if (isTargetTier1 && isTargetSponsor) { // 
      if (
        (!isLoggedInTier1 || // must be a logged in Tier1
        !isTargetSponsor) && // must have a Sponsor role
        !isSuperAdmin       // needs to have a Super Admin role
      ) {
        return {
          status: false,
          res: "Unauthorized Action: Tier1 Sponsors can only be managed by a Tier1 Sponsor.",
        };
      }
    }


    // Tier1 without Sponsor is invalid
    if (isTargetTier1 && !isTargetSponsor) {
      return {
        status: false,
        res: "User cannot have Tier1 role without being a Sponsor. Assign the Sponsor role and retry.",
      };
    }
    const { data: updatedUser } = await axios.post("/api/applicationusers/admin", state.user, {
      config: {
        showToast: true,
        message: "User Details Successfully Saved!!",
      },
    });

    commit("SET_USER", updatedUser);

    return { status: true, res: "User updated successfully." };

  } catch (error) {
    return
  }
},
  async updateUserProfile({ commit, state }) {
    commit(
        "SET_USER",
        await axios.post("/api/applicationusers/profile", state.user, {
          config: {
            showToast: true,
            message: "User Details Successfully Saved!!",
          },
        })
      );
    
  },
  async getLogisticsUsers({ commit }, getLocked) {
    commit(
      "SET_LOGISTICS_USERS",
      await axios.get(`/api/applicationusers/logistics/${getLocked}`)
    );
  },
  async getFinanceUsers({ commit }, getLocked) {
    commit(
      "SET_FINANCE_USERS",
      await axios.get(`/api/applicationusers/finance/${getLocked}`)

    );
  },
  async getPartnerNationUsers({ commit } , countryId) {
    try{
   
    commit(
      "SET_PARTNERNATION_USERS",
      await axios.get(`/api/applicationusers/partnernation/${countryId}/${true}`)
    );
  }catch(error){
    commit(
      "SET_PARTNERNATION_USERS",
      {data: []}
    );
  }

  },
  async getTier1Users({commit}){
    commit("SET_TIER1_USERS" , await axios.get('api/applicationusers/tier1'));
  },
  async getOUSDUsers({ commit }) {
    commit("SET_OUSD_USERS", await axios.get("/api/applicationusers/ousd"));
  },
  async getSponsorUsers({ commit }, showLocked) {
    var sponsors = '';
    if(showLocked != null) {
      sponsors = await axios.get(`/api/applicationusers/sponsor/${showLocked}`);
    } else {
      sponsors = await axios.get(`/api/applicationusers/sponsor`);
    }
    commit(
      "SET_SPONSOR_USERS",
      sponsors
    );
  }
};
